export const MODAL_TYPES = {
  okModal: 'OK_MODAL',
  yesNoModal: 'YES_NO_MODAL',
  emailConfirmationModal: 'EMAIL_CONFIRMATION_MODAL',
  contentModal: 'CONTENT_MODAL',
};
